import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import axios from 'axios';

const GetDistrictsRoleBased = ({ onChange, value }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URL}/api/loginbased/districts`)
            .then(res => {
                setOptions(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    if (loading) return <Skeleton width={200} height={40} />;

    return (
        <select onChange={(e) => onChange(e.target.value)} value={value} >
            <option value=" ">Select</option>
            {options.map(opt => (
                <option key={opt.dist_code} value={opt.dist_code}>
                    {opt.dist_name_en}
                </option>
            ))}
        </select>
    );
};

export default GetDistrictsRoleBased;